import React from 'react'
import PropTypes from 'prop-types'
import * as S from './styled'
import { Libras } from './Icon'

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'

const titleMenu = ['Institucional', 'Acesso Rápido', 'Canal Médico', 'Atendimento']

const handleTag = eventLabel => {
  if (window && window.dataLayer)
    window.dataLayer.push({
      event: 'institucional_footer',
      action: 'clicou_btn',
      clique: eventLabel,
    })
}

const Links = ({ footerLinks, socialLinks }) => (
  <>
    <Accordion allowZeroExpanded className="mobile">
      {footerLinks.map((links, index) => (
        <S.FooterLinksList key={index} data-testid="footer-menu">
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>
                <S.FooterTitleLinks data-testid="footer-links">
                  {titleMenu[index]}
                </S.FooterTitleLinks>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              {links.value.items.map(link => (
                <S.FooterLinksItems key={link.url}>
                  {link.url.match(/^https?:\/\/|tel?:/g) ? (
                    <S.FooterExternalLink
                      key={index}
                      rel="noopener noreferer"
                      href={link.url}
                      data-testid="footer-link"
                      onClick={() => handleTag(link.title)}
                    >
                      {link.title}
                    </S.FooterExternalLink>
                  ) : (
                    <S.FooterInternalLink key={index} to={link.url}>
                      {link.title}
                    </S.FooterInternalLink>
                  )}
                </S.FooterLinksItems>
              ))}
              <S.LastMenu>
                {index === 0 && (
                  <S.FooterExternalLink href="#" onClick={() => OneTrust.ToggleInfoDisplay() }>
                    Política de Cookies
                  </S.FooterExternalLink>
                )}
                {index === 3 && (
                  <S.FooterTel data-testid="footer-tels">
                    {!!socialLinks.libras_url && (
                      <S.FooterLibras data-testid="footer-libras">
                        <Libras className="icon-button" />
                        Atendimento em Libras
                      </S.FooterLibras>
                    )}
                  </S.FooterTel>
                )}
              </S.LastMenu>
            </AccordionItemPanel>
          </AccordionItem>
        </S.FooterLinksList>
      ))}
    </Accordion>

    {footerLinks.map((links, index) => (
      <S.FooterLinksList className="desktop" key={index} data-testid="footer-menu">
        <S.FooterTitleLinks data-testid="footer-links">{titleMenu[index]}</S.FooterTitleLinks>

        {links.value.items.map(link => (
          <S.FooterLinksItems key={link.url}>
            {link.url.match(/^https?:\/\/|tel?:/g) ? (
              <S.FooterExternalLink
                key={index}
                href={link.url}
                data-testid="footer-link"
                onClick={() => handleTag(link.title)}
              >
                {link.title}
              </S.FooterExternalLink>
            ) : (
              <S.FooterInternalLink key={index} to={link.url}>
                {link.title}
              </S.FooterInternalLink>
            )}
          </S.FooterLinksItems>
        ))}
        <S.LastMenu>
        {index === 0 && (
            <S.FooterExternalLink href="#" onClick={() => OneTrust.ToggleInfoDisplay() }>
              Política de Cookies
            </S.FooterExternalLink>
          )}
          {index === 3 && (
            <S.FooterTel data-testid="footer-tels">
              {!!socialLinks.libras_url && (
                <S.FooterLibras data-testid="footer-libras">
                  <Libras className="icon-button" />
                  Atendimento em Libras
                </S.FooterLibras>
              )}
            </S.FooterTel>
          )}
        </S.LastMenu>
      </S.FooterLinksList>
    ))}
  </>
)

Links.propTypes = {
  footerLinks: PropTypes.array.isRequired,
}

export default Links
